import { t } from '@gem/modules/i18n';

import { ReminderType } from 'APP/model/calendar/calendar.types';

import { UnitEnum } from '../../Form.types';

export const FORM_ID = 'customReminder-form';

export const UnitMap = {
  [UnitEnum.Minutes]: t('calendar_reminder_type_email'),
  [UnitEnum.Days]: t('calendar_reminder_type_email'),
  [UnitEnum.Hours]: t('calendar_reminder_type_email'),
  [UnitEnum.Weeks]: t('calendar_reminder_type_email'),
};

export const TypeMap = {
  [ReminderType.EMAIL]: 'calendar_reminder_type_email',
  // [ReminderType.POPUP]: 'calendar_reminder_type_notification',
};
